export enum AvailableFeature {
  PROTON = 'Link_Forge',
  CREATIVE_GENERATION = 'Creative Generation',
  CREATIVE_VOLUME_PLANNER = 'Creative Volume Planner',
}

export interface IGetFeatureResponse {
  id: string;
  name: AvailableFeature;
}

export interface IFeaturesResponse {
  wasSuccessfull: boolean;
  errorMessage: string;
}

export interface IGetFeaturesByCustomerIdResponse {
  features: Array<IGetFeatureResponse>;
}

export interface IGetFeatureAvailableResponse extends IFeaturesResponse {
  hasAccess: boolean;
}
